import { observer } from "mobx-react-lite";
import React from "react";

import "./BenefitsListTable.scss";

import AppStore from "stores/AppStore";
import BenefitsListStore from "stores/BenefitsListStore";
import BenefitsListTableHeader from "./components/BenefitsListTableHeader/BenefitsListTableHeader";
import BenefitsListTableRows from "./components/BenefitsListTableRows/BenefitsListTableRows";

const BenefitsListTable = () => {
  const { benefits } = BenefitsListStore;
  const {
    i18n: {
      employees: { nothingToShow }
    }
  } = AppStore;

  if (!benefits?.length) {
    return <h4 className="c-benefits-list-table__no-data">{nothingToShow}</h4>;
  }

  return (
    <table className="c-benefits-list-table">
      <BenefitsListTableHeader />
      <BenefitsListTableRows />
    </table>
  );
};

export default observer(BenefitsListTable);
